module.exports = __webpack_public_path__ + "static/media/chiot_laisse.b930cad8.png";